import {
  LayoutDashboard,
  Film,
  Armchair,
  UtensilsCrossed,
  Users,
  FileText,
  Sparkles,
  Monitor,
  Heart,
} from 'lucide-react'

export const NAV_ITEMS = [
  { id: 'overview', label: 'Overview', icon: LayoutDashboard },
  { id: 'shows', label: 'Shows & Scheduling', icon: Film },
  { id: 'occupancy', label: 'Seat Occupancy', icon: Armchair },
  { id: 'screens', label: 'Screen Config', icon: Monitor },
  { id: 'fb', label: 'F&B Operations', icon: UtensilsCrossed },
  { id: 'loyalty', label: 'Loyalty', icon: Heart },
  { id: 'staff', label: 'Staff', icon: Users },
  { id: 'reports', label: 'Reports', icon: FileText },
  { id: 'ai', label: 'AI Insights', icon: Sparkles },
]

export const SEAT_CATEGORIES = [
  { id: 'diamond', label: 'Diamond', color: '#7C3AED', price: 190 },
  { id: 'platinum', label: 'Platinum', color: '#2563EB', price: 190 },
  { id: 'gold', label: 'Gold', color: '#D97706', price: 150 },
  { id: 'silver', label: 'Silver', color: '#6B7280', price: 100 },
  { id: 'accessible', label: 'Accessible', color: '#059669', price: 100 },
  { id: 'couple', label: 'Couple', color: '#EC4899', price: 500 },
]

// Real seat map layouts per screen
// Each row: { label, category, seats: array of (number | null) where null = aisle gap }
export type SeatRow = {
  label: string
  category: 'diamond' | 'platinum' | 'gold' | 'silver'
  price: number
  seats: (number | null)[]
}

export type ScreenLayout = {
  screenId: number
  rows: SeatRow[]
}

// Screen 1 — 4K DOLBY ATMOS (from Thaai Kizhavi screenshot)
const screen1Layout: ScreenLayout = {
  screenId: 1,
  rows: [
    {
      label: 'A',
      category: 'diamond',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        5,
        null,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'B',
      category: 'diamond',
      price: 190,
      seats: [
        1,
        2,
        3,
        null,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
      ],
    },
    {
      label: 'C',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'D',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'E',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'F',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'G',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'H',
      category: 'gold',
      price: 150,
      seats: [
        null,
        null,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'I',
      category: 'gold',
      price: 150,
      seats: [
        null,
        null,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'J',
      category: 'gold',
      price: 150,
      seats: [
        null,
        null,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'K',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'L',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'M',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'N',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
    {
      label: 'O',
      category: 'silver',
      price: 100,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        null,
        20,
        21,
        22,
        23,
      ],
    },
  ],
}

// Screen 2 — Dolby Atmos (from Scream 7 screenshot)
const screen2Layout: ScreenLayout = {
  screenId: 2,
  rows: [
    {
      label: 'A',
      category: 'diamond',
      price: 210,
      seats: [1, 2, 3, 4, 5, 6, 7, 8, null, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    {
      label: 'B',
      category: 'platinum',
      price: 210,
      seats: [
        null,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        null,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
      ],
    },
    {
      label: 'C',
      category: 'platinum',
      price: 210,
      seats: [
        null,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        null,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
      ],
    },
    {
      label: 'D',
      category: 'gold',
      price: 210,
      seats: [
        null,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        null,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
      ],
    },
    {
      label: 'E',
      category: 'gold',
      price: 210,
      seats: [
        null,
        null,
        null,
        null,
        5,
        6,
        7,
        8,
        null,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
      ],
    },
    {
      label: 'F',
      category: 'gold',
      price: 210,
      seats: [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
      ],
    },
    {
      label: 'G',
      category: 'gold',
      price: 210,
      seats: [1, 2, 3, 4, 5, 6, 7, 8, null, 9, 10, 11, 12, 13, 14, 15, 16, 17],
    },
    {
      label: 'H',
      category: 'gold',
      price: 210,
      seats: [1, 2, 3, 4, 5, 6, 7, 8, null, 9, 10, 11, 12, 13, 14, 15, 16, 17],
    },
    {
      label: 'I',
      category: 'gold',
      price: 210,
      seats: [1, 2, 3, 4, 5, 6, 7, 8, null, 9, 10, 11, 12, 13, 14, 15, 16, 17],
    },
    {
      label: 'J',
      category: 'silver',
      price: 120,
      seats: [1, 2, 3, 4, 5, 6, 7, 8, null, 9, 10, 11, 12, 13, 14, 15, 16, 17],
    },
  ],
}

// Screen 3 — DOLBY 7.1
const screen3Layout: ScreenLayout = {
  screenId: 3,
  rows: [
    {
      label: 'A',
      category: 'diamond',
      price: 180,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14],
    },
    {
      label: 'B',
      category: 'diamond',
      price: 180,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14],
    },
    {
      label: 'C',
      category: 'platinum',
      price: 180,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    {
      label: 'D',
      category: 'platinum',
      price: 180,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    {
      label: 'E',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    {
      label: 'F',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    {
      label: 'G',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    {
      label: 'H',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
    {
      label: 'I',
      category: 'silver',
      price: 100,
      seats: [1, 2, 3, 4, 5, 6, null, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    },
  ],
}

// Screen 4 — Dolby Atmos (from Masthishka Maranam screenshot)
const screen4Layout: ScreenLayout = {
  screenId: 4,
  rows: [
    {
      label: 'A',
      category: 'diamond',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        7,
      ],
    },
    {
      label: 'B',
      category: 'diamond',
      price: 200,
      seats: [1, 2, 3, 4, 5, 6, 7, null, 8, 9, 10, 11, 12, 13, 14],
    },
    {
      label: 'C',
      category: 'platinum',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'D',
      category: 'platinum',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'E',
      category: 'gold',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'F',
      category: 'gold',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'G',
      category: 'gold',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'H',
      category: 'gold',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'I',
      category: 'gold',
      price: 200,
      seats: [
        null,
        null,
        null,
        null,
        null,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'J',
      category: 'gold',
      price: 200,
      seats: [
        null,
        null,
        null,
        null,
        null,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'K',
      category: 'gold',
      price: 200,
      seats: [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'L',
      category: 'gold',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'M',
      category: 'gold',
      price: 200,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
    {
      label: 'N',
      category: 'silver',
      price: 120,
      seats: [
        1,
        2,
        3,
        4,
        5,
        6,
        null,
        null,
        null,
        null,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ],
    },
  ],
}

// Screen 5 — 4K DOLBY ATMOS (similar to Screen 1)
const screen5Layout: ScreenLayout = {
  screenId: 5,
  rows: [
    {
      label: 'A',
      category: 'diamond',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'B',
      category: 'diamond',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'C',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'D',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'E',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'F',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'G',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'H',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'I',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'J',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
    {
      label: 'K',
      category: 'silver',
      price: 100,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        null,
        19,
        20,
        21,
        22,
      ],
    },
  ],
}

// Screen 6 — DOLBY 7.1 (similar to Screen 3)
const screen6Layout: ScreenLayout = {
  screenId: 6,
  rows: [
    {
      label: 'A',
      category: 'diamond',
      price: 180,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      label: 'B',
      category: 'platinum',
      price: 180,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      label: 'C',
      category: 'platinum',
      price: 180,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      label: 'D',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      label: 'E',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      label: 'F',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      label: 'G',
      category: 'gold',
      price: 150,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      label: 'H',
      category: 'silver',
      price: 100,
      seats: [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
  ],
}

// Screen 7 — 4K DOLBY ATMOS (similar to Screen 5)
const screen7Layout: ScreenLayout = {
  screenId: 7,
  rows: [
    {
      label: 'A',
      category: 'diamond',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'B',
      category: 'diamond',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'C',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'D',
      category: 'platinum',
      price: 190,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'E',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'F',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'G',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'H',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'I',
      category: 'gold',
      price: 150,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
    {
      label: 'J',
      category: 'silver',
      price: 100,
      seats: [
        1,
        2,
        3,
        4,
        null,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        null,
        17,
        18,
        19,
        20,
      ],
    },
  ],
}

export const SCREEN_SEAT_MAPS: ScreenLayout[] = [
  screen1Layout,
  screen2Layout,
  screen3Layout,
  screen4Layout,
  screen5Layout,
  screen6Layout,
  screen7Layout,
]

export const SCREENS_DATA = [
  {
    id: 1,
    name: 'Screen 1',
    type: '4K DOLBY ATMOS',
    capacity: 320,
    status: 'ACTIVE' as const,
  },
  {
    id: 2,
    name: 'Screen 2',
    type: 'Dolby Atmos',
    capacity: 250,
    status: 'ACTIVE' as const,
  },
  {
    id: 3,
    name: 'Screen 3',
    type: 'DOLBY 7.1',
    capacity: 180,
    status: 'ACTIVE' as const,
  },
  {
    id: 4,
    name: 'Screen 4',
    type: 'Dolby Atmos',
    capacity: 220,
    status: 'ACTIVE' as const,
  },
  {
    id: 5,
    name: 'Screen 5',
    type: '4K DOLBY ATMOS',
    capacity: 280,
    status: 'ACTIVE' as const,
  },
  {
    id: 6,
    name: 'Screen 6',
    type: 'DOLBY 7.1',
    capacity: 200,
    status: 'ACTIVE' as const,
  },
  {
    id: 7,
    name: 'Screen 7',
    type: '4K DOLBY ATMOS',
    capacity: 240,
    status: 'ACTIVE' as const,
  },
]

export const SHOWTIMES_DATA = [
  // Masthishka Maranam
  {
    id: 1,
    movie: 'Masthishka Maranam',
    screen: 'Screen 4',
    format: 'Dolby Atmos',
    language: 'Malayalam',
    date: '2026-03-01',
    startTime: '09:05',
    endTime: '11:30',
    status: 'SCHEDULED',
    occupancy: 42,
  },
  // Scream 7
  {
    id: 2,
    movie: 'Scream 7',
    screen: 'Screen 2',
    format: 'Dolby Atmos',
    language: 'English',
    date: '2026-03-01',
    startTime: '09:15',
    endTime: '11:30',
    status: 'SCHEDULED',
    occupancy: 58,
  },
  {
    id: 3,
    movie: 'Scream 7',
    screen: 'Screen 4',
    format: 'Dolby Atmos',
    language: 'English',
    date: '2026-03-01',
    startTime: '20:25',
    endTime: '22:40',
    status: 'SCHEDULED',
    occupancy: 72,
  },
  // Fourth Floor
  {
    id: 4,
    movie: 'Fourth Floor',
    screen: 'Screen 3',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '10:00',
    endTime: '12:15',
    status: 'SCHEDULED',
    occupancy: 65,
  },
  {
    id: 5,
    movie: 'Fourth Floor',
    screen: 'Screen 6',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '22:40',
    endTime: '01:00',
    status: 'SCHEDULED',
    occupancy: 38,
  },
  // The Kerala Story 2
  {
    id: 6,
    movie: 'The Kerala Story 2',
    screen: 'Screen 6',
    format: 'DOLBY 7.1',
    language: 'Hindi',
    date: '2026-03-01',
    startTime: '10:00',
    endTime: '12:30',
    status: 'SCHEDULED',
    occupancy: 55,
  },
  // My Lord
  {
    id: 7,
    movie: 'My Lord',
    screen: 'Screen 3',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '10:20',
    endTime: '12:50',
    status: 'SCHEDULED',
    occupancy: 48,
  },
  // Thaai Kizhavi — the blockbuster with 22 shows
  {
    id: 8,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 1',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '10:30',
    endTime: '13:00',
    status: 'HOUSEFULL',
    occupancy: 100,
  },
  {
    id: 9,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 5',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '11:10',
    endTime: '13:40',
    status: 'HOUSEFULL',
    occupancy: 100,
  },
  {
    id: 10,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 2',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '11:50',
    endTime: '14:20',
    status: 'SCHEDULED',
    occupancy: 94,
  },
  {
    id: 11,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 4',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '12:30',
    endTime: '15:00',
    status: 'SCHEDULED',
    occupancy: 91,
  },
  {
    id: 12,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 3',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '13:05',
    endTime: '15:35',
    status: 'SCHEDULED',
    occupancy: 88,
  },
  {
    id: 13,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 7',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '13:25',
    endTime: '15:55',
    status: 'HOUSEFULL',
    occupancy: 100,
  },
  {
    id: 14,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 6',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '13:40',
    endTime: '16:10',
    status: 'SCHEDULED',
    occupancy: 85,
  },
  {
    id: 15,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 5',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '14:05',
    endTime: '16:35',
    status: 'SCHEDULED',
    occupancy: 92,
  },
  {
    id: 16,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 2',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '14:35',
    endTime: '17:05',
    status: 'SCHEDULED',
    occupancy: 87,
  },
  {
    id: 17,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 4',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '15:15',
    endTime: '17:45',
    status: 'SCHEDULED',
    occupancy: 82,
  },
  {
    id: 18,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 1',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '17:00',
    endTime: '19:30',
    status: 'HOUSEFULL',
    occupancy: 100,
  },
  {
    id: 19,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 7',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '17:55',
    endTime: '20:25',
    status: 'SCHEDULED',
    occupancy: 95,
  },
  {
    id: 20,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 1',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '20:05',
    endTime: '22:35',
    status: 'SCHEDULED',
    occupancy: 90,
  },
  {
    id: 21,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 5',
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '22:10',
    endTime: '00:40',
    status: 'SCHEDULED',
    occupancy: 68,
  },
  {
    id: 22,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 2',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '22:30',
    endTime: '01:00',
    status: 'SCHEDULED',
    occupancy: 55,
  },
  {
    id: 23,
    movie: 'Thaai Kizhavi',
    screen: 'Screen 4',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '22:50',
    endTime: '01:20',
    status: 'SCHEDULED',
    occupancy: 45,
  },
  // Theri
  {
    id: 24,
    movie: 'Theri',
    screen: 'Screen 3',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '10:35',
    endTime: '13:15',
    status: 'SCHEDULED',
    occupancy: 76,
  },
  {
    id: 25,
    movie: 'Theri',
    screen: 'Screen 2',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '22:50',
    endTime: '01:30',
    status: 'SCHEDULED',
    occupancy: 52,
  },
  // With Love
  {
    id: 26,
    movie: 'With Love',
    screen: 'Screen 2',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '11:30',
    endTime: '14:00',
    status: 'SCHEDULED',
    occupancy: 70,
  },
  {
    id: 27,
    movie: 'With Love',
    screen: 'Screen 4',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '14:15',
    endTime: '16:45',
    status: 'SCHEDULED',
    occupancy: 65,
  },
  {
    id: 28,
    movie: 'With Love',
    screen: 'Screen 2',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '17:00',
    endTime: '19:30',
    status: 'SCHEDULED',
    occupancy: 78,
  },
  {
    id: 29,
    movie: 'With Love',
    screen: 'Screen 6',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '17:40',
    endTime: '20:10',
    status: 'SCHEDULED',
    occupancy: 62,
  },
  {
    id: 30,
    movie: 'With Love',
    screen: 'Screen 3',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '19:35',
    endTime: '22:05',
    status: 'SCHEDULED',
    occupancy: 74,
  },
  {
    id: 31,
    movie: 'With Love',
    screen: 'Screen 6',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '22:20',
    endTime: '00:50',
    status: 'SCHEDULED',
    occupancy: 40,
  },
  // Couple Friendly
  {
    id: 32,
    movie: 'Couple Friendly',
    screen: 'Screen 3',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '12:35',
    endTime: '15:00',
    status: 'SCHEDULED',
    occupancy: 58,
  },
  // Sweety Naughty Crazy
  {
    id: 33,
    movie: 'Sweety Naughty Crazy',
    screen: 'Screen 6',
    format: 'DOLBY 7.1',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '14:55',
    endTime: '17:20',
    status: 'SCHEDULED',
    occupancy: 35,
  },
  // Second Case of Seetharam
  {
    id: 34,
    movie: 'Second Case of Seetharam',
    screen: 'Screen 4',
    format: 'Dolby Atmos',
    language: 'Tamil',
    date: '2026-03-01',
    startTime: '20:45',
    endTime: '23:15',
    status: 'SCHEDULED',
    occupancy: 60,
  },
]

export const THEME_COLORS = [
  { id: 'red', value: '#D62828' },
  { id: 'blue', value: '#2563EB' },
  { id: 'green', value: '#059669' },
  { id: 'purple', value: '#7C3AED' },
  { id: 'amber', value: '#D97706' },
  { id: 'cyan', value: '#0891B2' },
]

export const METRICS = [
  {
    id: 'occupancy',
    label: 'Occupancy Rate',
    value: '89.1%',
    trend: '↑ 4.3%',
    trendUp: true,
  },
  {
    id: 'shows',
    label: 'Shows Today',
    value: '34',
    trend: '↑ 6 vs yesterday',
    trendUp: true,
  },
  {
    id: 'gross',
    label: 'Gross Revenue',
    value: '₹8,64,200',
    trend: '↑ 12.8%',
    trendUp: true,
  },
  {
    id: 'fb_rev',
    label: 'F&B Revenue',
    value: '₹2,18,400',
    trend: '↑ 6.1%',
    trendUp: true,
  },
  {
    id: 'tickets',
    label: 'Tickets Sold',
    value: '5,420',
    trend: '↑ 9.2%',
    trendUp: true,
  },
]

export const SHOWS = [
  {
    id: 1,
    title: 'Thaai Kizhavi',
    screen: 'Screen 1',
    time: '10:30 AM',
    occupancy: 100,
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    color: 'bg-red-600',
    posterColor: 'from-red-500 to-red-700',
    posterImage:
      'https://cdn.magicpatterns.com/uploads/iFmj425p559JWvUi3CCHYY/Screenshot_2026-02-28_at_9.14.04_PM.png',
  },
  {
    id: 2,
    title: 'Scream 7',
    screen: 'Screen 2',
    time: '09:15 AM',
    occupancy: 58,
    format: 'Dolby Atmos',
    language: 'English',
    color: 'bg-orange-500',
    posterColor: 'from-gray-700 to-gray-900',
    posterImage:
      'https://cdn.magicpatterns.com/uploads/puiKCfpNrosgzspb42tj3x/Screenshot_2026-02-28_at_9.14.24_PM.png',
  },
  {
    id: 3,
    title: 'Fourth Floor',
    screen: 'Screen 3',
    time: '10:00 AM',
    occupancy: 65,
    format: 'DOLBY 7.1',
    language: 'Tamil',
    color: 'bg-yellow-500',
    posterColor: 'from-amber-400 to-amber-600',
    posterImage:
      'https://cdn.magicpatterns.com/uploads/vAoxwRBJwuGAguqGBiYSCy/Screenshot_2026-02-28_at_9.14.12_PM.png',
  },
  {
    id: 4,
    title: 'Masthishka Maranam',
    screen: 'Screen 4',
    time: '09:05 AM',
    occupancy: 42,
    format: 'Dolby Atmos',
    language: 'Malayalam',
    color: 'bg-orange-500',
    posterColor: 'from-teal-500 to-teal-700',
    posterImage:
      'https://cdn.magicpatterns.com/uploads/fuSyEtGCVAQGJZV7ib1WTk/Screenshot_2026-02-28_at_9.14.31_PM.png',
  },
  {
    id: 5,
    title: 'Thaai Kizhavi',
    screen: 'Screen 5',
    time: '11:10 AM',
    occupancy: 100,
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    color: 'bg-red-600',
    posterColor: 'from-red-500 to-red-700',
    posterImage:
      'https://cdn.magicpatterns.com/uploads/iFmj425p559JWvUi3CCHYY/Screenshot_2026-02-28_at_9.14.04_PM.png',
  },
  {
    id: 6,
    title: 'The Kerala Story 2',
    screen: 'Screen 6',
    time: '10:00 AM',
    occupancy: 55,
    format: 'DOLBY 7.1',
    language: 'Hindi',
    color: 'bg-yellow-500',
    posterColor: 'from-orange-400 to-orange-600',
    posterImage: '',
  },
  {
    id: 7,
    title: 'Thaai Kizhavi',
    screen: 'Screen 7',
    time: '01:25 PM',
    occupancy: 100,
    format: '4K DOLBY ATMOS',
    language: 'Tamil',
    color: 'bg-red-600',
    posterColor: 'from-red-500 to-red-700',
    posterImage:
      'https://cdn.magicpatterns.com/uploads/iFmj425p559JWvUi3CCHYY/Screenshot_2026-02-28_at_9.14.04_PM.png',
  },
  {
    id: 8,
    title: 'With Love',
    screen: 'Screen 2',
    time: '11:30 AM',
    occupancy: 70,
    format: 'Dolby Atmos',
    language: 'Tamil',
    color: 'bg-green-500',
    posterColor: 'from-sky-300 to-sky-500',
    posterImage:
      'https://cdn.magicpatterns.com/uploads/tQK9pZJwEjwDFExhsA9jxQ/Screenshot_2026-02-28_at_9.14.41_PM.png',
  },
]

// Movie poster lookup for use across components
export const MOVIE_POSTERS: Record<string, string> = {
  'Thaai Kizhavi':
    'https://cdn.magicpatterns.com/uploads/iFmj425p559JWvUi3CCHYY/Screenshot_2026-02-28_at_9.14.04_PM.png',
  'Fourth Floor':
    'https://cdn.magicpatterns.com/uploads/vAoxwRBJwuGAguqGBiYSCy/Screenshot_2026-02-28_at_9.14.12_PM.png',
  'Masthishka Maranam':
    'https://cdn.magicpatterns.com/uploads/fuSyEtGCVAQGJZV7ib1WTk/Screenshot_2026-02-28_at_9.14.31_PM.png',
  'With Love':
    'https://cdn.magicpatterns.com/uploads/tQK9pZJwEjwDFExhsA9jxQ/Screenshot_2026-02-28_at_9.14.41_PM.png',
  'Couple Friendly':
    'https://cdn.magicpatterns.com/uploads/1tahvG7nruUGiJsSvwsQR6/Screenshot_2026-02-28_at_9.14.46_PM.png',
  'My Lord':
    'https://cdn.magicpatterns.com/uploads/mrsy8oAEZM6zz5Dsgzn3Yi/Screenshot_2026-02-28_at_9.14.50_PM.png',
  'Sweety Naughty Crazy':
    'https://cdn.magicpatterns.com/uploads/1boq2Q9XQzZAneUBTfWdqQ/Screenshot_2026-02-28_at_9.14.53_PM.png',
  'Second Case of Seetharam':
    'https://cdn.magicpatterns.com/uploads/6PE6gPyVkJsDUJWx9Ztquy/Screenshot_2026-02-28_at_9.14.59_PM.png',
}

export const REVENUE_DATA = [
  { day: 'Mon', revenue: 0.55 },
  { day: 'Tue', revenue: 0.48 },
  { day: 'Wed', revenue: 0.62 },
  { day: 'Thu', revenue: 0.58 },
  { day: 'Fri', revenue: 0.88 },
  { day: 'Sat', revenue: 0.95 },
  { day: 'Sun', revenue: 1.0 },
]

export const TOP_FILMS = [
  {
    id: 1,
    rank: 1,
    title: 'Thaai Kizhavi',
    shows: 22,
    tickets: '4,840',
    revenue: '₹14,52,000',
    occupancy: '92%',
  },
  {
    id: 2,
    rank: 2,
    title: 'With Love',
    shows: 6,
    tickets: '1,080',
    revenue: '₹3,24,000',
    occupancy: '65%',
  },
  {
    id: 3,
    rank: 3,
    title: 'Theri',
    shows: 2,
    tickets: '380',
    revenue: '₹1,14,000',
    occupancy: '64%',
  },
  {
    id: 4,
    rank: 4,
    title: 'Scream 7',
    shows: 2,
    tickets: '325',
    revenue: '₹97,500',
    occupancy: '65%',
  },
  {
    id: 5,
    rank: 5,
    title: 'Fourth Floor',
    shows: 2,
    tickets: '258',
    revenue: '₹77,400',
    occupancy: '52%',
  },
  {
    id: 6,
    rank: 6,
    title: 'Second Case of Seetharam',
    shows: 1,
    tickets: '132',
    revenue: '₹39,600',
    occupancy: '60%',
  },
  {
    id: 7,
    rank: 7,
    title: 'The Kerala Story 2',
    shows: 1,
    tickets: '110',
    revenue: '₹33,000',
    occupancy: '55%',
  },
]

export const SCREEN_OCCUPANCY = [
  {
    id: 1,
    name: 'Screen 1',
    shows: [
      { time: '10:30 AM', film: 'Thaai Kizhavi', occupancy: 100 },
      { time: '5:00 PM', film: 'Thaai Kizhavi', occupancy: 100 },
      { time: '8:05 PM', film: 'Thaai Kizhavi', occupancy: 90 },
    ],
  },
  {
    id: 2,
    name: 'Screen 2',
    shows: [
      { time: '9:15 AM', film: 'Scream 7', occupancy: 58 },
      { time: '11:30 AM', film: 'With Love', occupancy: 70 },
      { time: '11:50 AM', film: 'Thaai Kizhavi', occupancy: 94 },
      { time: '2:35 PM', film: 'Thaai Kizhavi', occupancy: 87 },
      { time: '5:00 PM', film: 'With Love', occupancy: 78 },
      { time: '10:30 PM', film: 'Thaai Kizhavi', occupancy: 55 },
    ],
  },
  {
    id: 3,
    name: 'Screen 3',
    shows: [
      { time: '10:00 AM', film: 'Fourth Floor', occupancy: 65 },
      { time: '10:35 AM', film: 'Theri', occupancy: 76 },
      { time: '12:35 PM', film: 'Couple Friendly', occupancy: 58 },
      { time: '1:05 PM', film: 'Thaai Kizhavi', occupancy: 88 },
      { time: '7:35 PM', film: 'With Love', occupancy: 74 },
    ],
  },
  {
    id: 4,
    name: 'Screen 4',
    shows: [
      { time: '9:05 AM', film: 'Masthishka Maranam', occupancy: 42 },
      { time: '12:30 PM', film: 'Thaai Kizhavi', occupancy: 91 },
      { time: '3:15 PM', film: 'Thaai Kizhavi', occupancy: 82 },
      { time: '8:45 PM', film: 'Second Case of Seetharam', occupancy: 60 },
      { time: '10:50 PM', film: 'Thaai Kizhavi', occupancy: 45 },
    ],
  },
  {
    id: 5,
    name: 'Screen 5',
    shows: [
      { time: '11:10 AM', film: 'Thaai Kizhavi', occupancy: 100 },
      { time: '2:05 PM', film: 'Thaai Kizhavi', occupancy: 92 },
      { time: '5:20 PM', film: 'Thaai Kizhavi', occupancy: 95 },
      { time: '10:10 PM', film: 'Thaai Kizhavi', occupancy: 68 },
    ],
  },
  {
    id: 6,
    name: 'Screen 6',
    shows: [
      { time: '10:00 AM', film: 'The Kerala Story 2', occupancy: 55 },
      { time: '1:40 PM', film: 'Thaai Kizhavi', occupancy: 85 },
      { time: '2:55 PM', film: 'Sweety Naughty Crazy', occupancy: 35 },
      { time: '5:40 PM', film: 'With Love', occupancy: 62 },
      { time: '10:20 PM', film: 'With Love', occupancy: 40 },
      { time: '10:40 PM', film: 'Fourth Floor', occupancy: 38 },
    ],
  },
  {
    id: 7,
    name: 'Screen 7',
    shows: [
      { time: '1:25 PM', film: 'Thaai Kizhavi', occupancy: 100 },
      { time: '7:55 PM', film: 'Thaai Kizhavi', occupancy: 95 },
    ],
  },
]

// ==========================================
// F&B CATALOGUE & INVENTORY DATA
// ==========================================

export type DietaryType = 'VEG' | 'NON_VEG' | 'VEGAN'
export type StockStatus = 'IN_STOCK' | 'LOW_STOCK' | 'OUT_OF_STOCK'
export type Allergen =
  | 'Gluten'
  | 'Dairy'
  | 'Eggs'
  | 'Nuts'
  | 'Peanuts'
  | 'Soy'
  | 'Shellfish'
  | 'Fish'
  | 'Sesame'
  | 'Sulphites'

export interface FBCategory {
  id: string
  name: string
  order: number
}

export interface FBItem {
  id: string
  name: string
  categoryId: string
  description: string
  dietaryType: DietaryType
  price: number
  image: string | null
  status: StockStatus
  allergens: Allergen[]
  nutrition: {
    servingSize?: string
    calories?: number
    protein?: number
    carbs?: number
    fat?: number
  } | null
  currentStock: number
  lowStockThreshold: number
  lastUpdated: string
}

export interface AuditEntry {
  id: string
  itemId: string
  timestamp: string
  user: string
  oldQty: number
  newQty: number
  note: string
}

export const FB_CATEGORIES: FBCategory[] = [
  { id: 'snacks', name: 'Snacks', order: 1 },
  { id: 'beverages', name: 'Beverages', order: 2 },
  { id: 'combos', name: 'Combos', order: 3 },
  { id: 'desserts', name: 'Desserts', order: 4 },
  { id: 'hot-food', name: 'Hot Food', order: 5 },
]

export const FB_ITEMS: FBItem[] = [
  // Snacks
  {
    id: 'fb-1',
    name: 'Classic Salted Popcorn',
    categoryId: 'snacks',
    description:
      'Freshly popped corn with the perfect amount of salt. A cinema classic.',
    dietaryType: 'VEGAN',
    price: 180,
    image:
      'https://cdn.magicpatterns.com/uploads/jhMg6D2DN9q74FLjKAUVee/Screenshot_2026-02-28_at_9.17.47_PM.png',
    status: 'IN_STOCK',
    allergens: [],
    nutrition: {
      servingSize: 'Large Tub (120g)',
      calories: 420,
      protein: 4,
      carbs: 52,
      fat: 22,
    },
    currentStock: 150,
    lowStockThreshold: 30,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-2',
    name: 'Caramel Popcorn',
    categoryId: 'snacks',
    description: 'Sweet caramel-coated popcorn. Irresistibly crunchy.',
    dietaryType: 'VEG',
    price: 220,
    image:
      'https://cdn.magicpatterns.com/uploads/jhMg6D2DN9q74FLjKAUVee/Screenshot_2026-02-28_at_9.17.47_PM.png',
    status: 'IN_STOCK',
    allergens: ['Dairy'],
    nutrition: {
      servingSize: 'Large Tub (120g)',
      calories: 510,
      protein: 3,
      carbs: 68,
      fat: 26,
    },
    currentStock: 80,
    lowStockThreshold: 20,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-3',
    name: 'Cheese Nachos',
    categoryId: 'snacks',
    description: 'Crispy tortilla chips with warm cheese sauce and jalapeños.',
    dietaryType: 'VEG',
    price: 200,
    image:
      'https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?w=400&h=300&fit=crop',
    status: 'LOW_STOCK',
    allergens: ['Dairy', 'Gluten'],
    nutrition: {
      servingSize: '1 Plate (150g)',
      calories: 480,
      protein: 8,
      carbs: 45,
      fat: 30,
    },
    currentStock: 12,
    lowStockThreshold: 15,
    lastUpdated: '2026-03-01T10:30:00',
  },
  {
    id: 'fb-4',
    name: 'Masala Fries',
    categoryId: 'snacks',
    description: 'Crispy french fries tossed in special masala seasoning.',
    dietaryType: 'VEGAN',
    price: 150,
    image:
      'https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Gluten'],
    nutrition: {
      servingSize: '1 Portion (180g)',
      calories: 380,
      protein: 5,
      carbs: 48,
      fat: 20,
    },
    currentStock: 65,
    lowStockThreshold: 20,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-5',
    name: 'Chicken Popcorn',
    categoryId: 'snacks',
    description: 'Bite-sized crispy chicken pieces with spicy mayo dip.',
    dietaryType: 'NON_VEG',
    price: 250,
    image:
      'https://images.unsplash.com/photo-1562967914-608f82629710?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Gluten', 'Eggs'],
    nutrition: {
      servingSize: '1 Box (200g)',
      calories: 520,
      protein: 28,
      carbs: 32,
      fat: 30,
    },
    currentStock: 40,
    lowStockThreshold: 15,
    lastUpdated: '2026-03-01T09:15:00',
  },
  {
    id: 'fb-6',
    name: 'Paneer Tikka Bites',
    categoryId: 'snacks',
    description: 'Grilled paneer cubes marinated in tandoori spices.',
    dietaryType: 'VEG',
    price: 230,
    image:
      'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=400&h=300&fit=crop',
    status: 'OUT_OF_STOCK',
    allergens: ['Dairy'],
    nutrition: {
      servingSize: '1 Box (180g)',
      calories: 340,
      protein: 18,
      carbs: 12,
      fat: 24,
    },
    currentStock: 0,
    lowStockThreshold: 10,
    lastUpdated: '2026-03-01T11:00:00',
  },

  // Beverages
  {
    id: 'fb-7',
    name: 'Pepsi (Large)',
    categoryId: 'beverages',
    description: 'Chilled Pepsi served in a large cup with ice.',
    dietaryType: 'VEGAN',
    price: 150,
    image:
      'https://images.unsplash.com/photo-1629203851122-3726ecdf080e?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: [],
    nutrition: {
      servingSize: '500ml',
      calories: 210,
      protein: 0,
      carbs: 54,
      fat: 0,
    },
    currentStock: 200,
    lowStockThreshold: 50,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-8',
    name: 'Masala Chai',
    categoryId: 'beverages',
    description: 'Hot Indian spiced tea with milk and sugar.',
    dietaryType: 'VEG',
    price: 60,
    image:
      'https://images.unsplash.com/photo-1597318181409-cf64d0b5d8a2?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Dairy'],
    nutrition: {
      servingSize: '200ml',
      calories: 80,
      protein: 2,
      carbs: 14,
      fat: 2,
    },
    currentStock: 100,
    lowStockThreshold: 25,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-9',
    name: 'Fresh Lime Soda',
    categoryId: 'beverages',
    description: 'Refreshing lime juice with soda water. Sweet or salted.',
    dietaryType: 'VEGAN',
    price: 90,
    image:
      'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: [],
    nutrition: {
      servingSize: '300ml',
      calories: 65,
      protein: 0,
      carbs: 16,
      fat: 0,
    },
    currentStock: 75,
    lowStockThreshold: 20,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-10',
    name: 'Mango Lassi',
    categoryId: 'beverages',
    description: 'Thick mango yogurt smoothie. A crowd favourite.',
    dietaryType: 'VEG',
    price: 120,
    image:
      'https://images.unsplash.com/photo-1527661591475-527312dd65f5?w=400&h=300&fit=crop',
    status: 'LOW_STOCK',
    allergens: ['Dairy'],
    nutrition: {
      servingSize: '350ml',
      calories: 240,
      protein: 6,
      carbs: 42,
      fat: 5,
    },
    currentStock: 8,
    lowStockThreshold: 10,
    lastUpdated: '2026-03-01T10:00:00',
  },
  {
    id: 'fb-11',
    name: 'Filter Coffee',
    categoryId: 'beverages',
    description: 'South Indian filter coffee served in a traditional tumbler.',
    dietaryType: 'VEG',
    price: 80,
    image:
      'https://images.unsplash.com/photo-1610889556528-9a770e32642f?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Dairy'],
    nutrition: {
      servingSize: '150ml',
      calories: 60,
      protein: 2,
      carbs: 8,
      fat: 2,
    },
    currentStock: 90,
    lowStockThreshold: 20,
    lastUpdated: '2026-03-01T08:00:00',
  },

  // Combos
  {
    id: 'fb-12',
    name: 'Movie Night Combo',
    categoryId: 'combos',
    description: 'Large Popcorn + 2 Pepsi (Large). Best value for couples.',
    dietaryType: 'VEGAN',
    price: 399,
    image:
      'https://images.unsplash.com/photo-1585647347483-22b66260dfff?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: [],
    nutrition: null,
    currentStock: 50,
    lowStockThreshold: 10,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-13',
    name: 'Family Pack',
    categoryId: 'combos',
    description: '2 Large Popcorn + 4 Pepsi + Nachos. Perfect for families.',
    dietaryType: 'VEG',
    price: 699,
    image:
      'https://images.unsplash.com/photo-1505686994434-e3cc5abf1330?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Dairy', 'Gluten'],
    nutrition: null,
    currentStock: 30,
    lowStockThreshold: 8,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-14',
    name: 'Snack Attack',
    categoryId: 'combos',
    description:
      'Nachos + Chicken Popcorn + 2 Pepsi. For the hungry moviegoer.',
    dietaryType: 'NON_VEG',
    price: 549,
    image:
      'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=400&h=300&fit=crop',
    status: 'LOW_STOCK',
    allergens: ['Dairy', 'Gluten', 'Eggs'],
    nutrition: null,
    currentStock: 5,
    lowStockThreshold: 8,
    lastUpdated: '2026-03-01T11:30:00',
  },

  // Desserts
  {
    id: 'fb-15',
    name: 'Chocolate Brownie',
    categoryId: 'desserts',
    description: 'Warm, gooey chocolate brownie with vanilla ice cream.',
    dietaryType: 'VEG',
    price: 180,
    image:
      'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Dairy', 'Eggs', 'Gluten', 'Nuts'],
    nutrition: {
      servingSize: '1 Piece (100g)',
      calories: 380,
      protein: 5,
      carbs: 48,
      fat: 20,
    },
    currentStock: 35,
    lowStockThreshold: 10,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-16',
    name: 'Vanilla Ice Cream Cup',
    categoryId: 'desserts',
    description: 'Creamy vanilla ice cream in a waffle cup.',
    dietaryType: 'VEG',
    price: 100,
    image:
      'https://images.unsplash.com/photo-1570197788417-0e82375c9371?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Dairy', 'Gluten'],
    nutrition: {
      servingSize: '1 Cup (120ml)',
      calories: 220,
      protein: 3,
      carbs: 28,
      fat: 12,
    },
    currentStock: 45,
    lowStockThreshold: 15,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-17',
    name: 'Gulab Jamun (2 pcs)',
    categoryId: 'desserts',
    description: 'Soft, syrupy gulab jamun. A traditional Indian sweet.',
    dietaryType: 'VEG',
    price: 80,
    image:
      'https://images.unsplash.com/photo-1666190050346-fbe1e3a1d0d5?w=400&h=300&fit=crop',
    status: 'OUT_OF_STOCK',
    allergens: ['Dairy', 'Gluten'],
    nutrition: {
      servingSize: '2 Pieces (80g)',
      calories: 300,
      protein: 4,
      carbs: 52,
      fat: 10,
    },
    currentStock: 0,
    lowStockThreshold: 10,
    lastUpdated: '2026-03-01T12:00:00',
  },

  // Hot Food
  {
    id: 'fb-18',
    name: 'Veg Burger',
    categoryId: 'hot-food',
    description: 'Crispy veg patty with lettuce, tomato, and special sauce.',
    dietaryType: 'VEG',
    price: 180,
    image:
      'https://images.unsplash.com/photo-1520072959219-c595e6cdc07e?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Gluten', 'Dairy'],
    nutrition: {
      servingSize: '1 Burger (220g)',
      calories: 420,
      protein: 12,
      carbs: 48,
      fat: 20,
    },
    currentStock: 25,
    lowStockThreshold: 10,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-19',
    name: 'Chicken Burger',
    categoryId: 'hot-food',
    description: 'Juicy chicken patty with cheese, lettuce, and mayo.',
    dietaryType: 'NON_VEG',
    price: 220,
    image:
      'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Gluten', 'Dairy', 'Eggs'],
    nutrition: {
      servingSize: '1 Burger (250g)',
      calories: 520,
      protein: 28,
      carbs: 42,
      fat: 26,
    },
    currentStock: 20,
    lowStockThreshold: 8,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-20',
    name: 'Samosa (2 pcs)',
    categoryId: 'hot-food',
    description: 'Crispy pastry filled with spiced potato and peas.',
    dietaryType: 'VEGAN',
    price: 60,
    image:
      'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400&h=300&fit=crop',
    status: 'IN_STOCK',
    allergens: ['Gluten'],
    nutrition: {
      servingSize: '2 Pieces (120g)',
      calories: 280,
      protein: 5,
      carbs: 36,
      fat: 14,
    },
    currentStock: 60,
    lowStockThreshold: 20,
    lastUpdated: '2026-03-01T08:00:00',
  },
  {
    id: 'fb-21',
    name: 'Veg Hotdog',
    categoryId: 'hot-food',
    description: 'Grilled veg sausage in a soft bun with mustard and ketchup.',
    dietaryType: 'VEG',
    price: 140,
    image:
      'https://images.unsplash.com/photo-1612392062126-2f5b0ced3d2e?w=400&h=300&fit=crop',
    status: 'LOW_STOCK',
    allergens: ['Gluten', 'Soy'],
    nutrition: {
      servingSize: '1 Hotdog (180g)',
      calories: 350,
      protein: 10,
      carbs: 40,
      fat: 16,
    },
    currentStock: 6,
    lowStockThreshold: 8,
    lastUpdated: '2026-03-01T10:45:00',
  },
]

export const FB_AUDIT_LOG: AuditEntry[] = [
  {
    id: 'a1',
    itemId: 'fb-3',
    timestamp: '2026-03-01T10:30:00',
    user: 'Anjali R',
    oldQty: 25,
    newQty: 12,
    note: 'Sold during morning rush',
  },
  {
    id: 'a2',
    itemId: 'fb-6',
    timestamp: '2026-03-01T11:00:00',
    user: 'Ravi K',
    oldQty: 8,
    newQty: 0,
    note: 'Sold out — supplier delivery expected tomorrow',
  },
  {
    id: 'a3',
    itemId: 'fb-10',
    timestamp: '2026-03-01T10:00:00',
    user: 'Anjali R',
    oldQty: 20,
    newQty: 8,
    note: 'High demand during matinee shows',
  },
  {
    id: 'a4',
    itemId: 'fb-14',
    timestamp: '2026-03-01T11:30:00',
    user: 'Priya S',
    oldQty: 15,
    newQty: 5,
    note: 'Running low — reorder placed',
  },
  {
    id: 'a5',
    itemId: 'fb-17',
    timestamp: '2026-03-01T12:00:00',
    user: 'Ravi K',
    oldQty: 6,
    newQty: 0,
    note: 'Sold out for the day',
  },
  {
    id: 'a6',
    itemId: 'fb-21',
    timestamp: '2026-03-01T10:45:00',
    user: 'Anjali R',
    oldQty: 18,
    newQty: 6,
    note: 'Popular with afternoon crowd',
  },
  {
    id: 'a7',
    itemId: 'fb-1',
    timestamp: '2026-02-28T22:00:00',
    user: 'Ravi K',
    oldQty: 50,
    newQty: 150,
    note: 'Restocked from warehouse',
  },
  {
    id: 'a8',
    itemId: 'fb-7',
    timestamp: '2026-02-28T22:00:00',
    user: 'Ravi K',
    oldQty: 80,
    newQty: 200,
    note: 'Full restock for weekend',
  },
]
